import { Routes, Route } from 'react-router-dom';

import RequiresAuth from './Auth/RequiresAuth';
import AddEditActivity from './Activity/AddEditActivity';
import ActivityLog from './Activity/ActivityLog';
import Strava from './Strava/Strava';
import StravaCallback from './Strava/StravaCallback';

function AuthorisedParticipant () 
{
    return  <RequiresAuth>
                <Routes>
                    <Route path="/log/:activityId" element={ <AddEditActivity /> } />
                    <Route path="/log" exact element={ <ActivityLog /> } />
                    <Route path="/add" element={ <AddEditActivity /> } />
                    <Route path="/strava" element={ <Strava /> } />
                    <Route path="/strava/callback" element={ <StravaCallback /> } />
                </Routes>
            </RequiresAuth>
}

export default AuthorisedParticipant;